import { MessageSeverity } from './message-severity';

export class Message {

    Title: string;
    Text: string;
    Severity: MessageSeverity;
    Duration: number;
    Date: Date;
    /**
    * Use this class to handle notification messages.
    *
    * @example <caption> create a new message </caption>
    * let msg = new Message(message, 3, title, duration);
    *
    * @param text the text you want to be displayed
    *
    * @param severity the different type of message
            0 => Error
            1 => Warning
            2 => Info
            3 => Success
    *
    * @param title the title <deprecated> for the moment </deprecated>
    *
    * @param duration the duration of the message in ms
    */
    constructor(text: string, severity?: MessageSeverity, duration?: number, title?: string) {
        this.Text = text;
        this.Severity = severity ? severity : MessageSeverity.Error;
        this.Duration = duration ? duration : 5000;
        this.Title = title ? title : '';
        this.Date = new Date();
    }
}
